import { render, staticRenderFns } from "./ProjectEditSurfaceCost.vue?vue&type=template&id=84595154&"
import script from "./ProjectEditSurfaceCost.vue?vue&type=script&lang=js&"
export * from "./ProjectEditSurfaceCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports